module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.localValue),
      expression: "localValue",
      modifiers: {
        "number": true
      }
    }],
    staticStyle: {
      "width": "75px"
    },
    attrs: {
      "type": "number",
      "disabled": _vm.isDisabled
    },
    domProps: {
      "value": (_vm.localValue)
    },
    on: {
      "change": _vm.onChange,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.localValue = _vm._n($event.target.value)
      }, function($event) {
        _vm.localValue = _vm.numberInput($event.target.value);
      }],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4117d67b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/form/QuantityInput.vue
// module id = 3144
// module chunks = 0